/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCustomerFacingService = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h20v16h-9v2h4v2H7v-2h4v-2H2zm2 2v12h3.055c.123-1.047.465-1.98 1.154-2.694C9.117 12.364 10.436 12 12 12s2.883.364 3.791 1.306c.689.714 1.03 1.647 1.154 2.694H20V4zm10.926 12c-.104-.622-.311-1.033-.574-1.306C13.974 14.303 13.292 14 12 14s-1.974.303-2.352.694c-.263.273-.47.684-.574 1.306zM12 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM9 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCustomerFacingService as CustomerFacingService };
